export default function SmartCardIssuance() {
    return(
        <></>
    )
}